var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("district.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "provinceName",
                  label: _vm.$t("district.table.province"),
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cityName",
                  label: _vm.$t("district.table.city"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "countryName",
                  label: _vm.$t("district.table.area"),
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }